export default "__VITE_ASSET__DL1VGW28__"